import React, { useMemo, useState } from 'react';
import moment from 'moment';
import KeywordCorrelationCloud from './widgets/cloud';
import KeywordCorrelationWords from './widgets/words';
import { Layout } from 'tea-component';
import { connect, useIntl } from 'umi';
import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import CardLoading from '../../components/CardLoading';
import FilterBoxCommon from '../../components/FilterBoxCommon';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import keywordCorrelation from '@op/operationLog/pages/keywordCorrelation';
import ContentBody from '../../components/ContentBody';
import { DBO_TM } from '@op/utils/format';
const { Content } = Layout;

function KeywordCorrelation({ gameInfo }: any) {
  const { formatMessage } = useIntl();
  useInitBuriedPointInfo({ buriedPoint: keywordCorrelation });
  const { loading, filter, changeFilter, filterOptions, scrollBody } =
    useFilterDataHook({
      gameInfo,
      pageName: 'Stats_Keyword_Correlation',
    });

  const keepParams = useMemo(() => {
    return {
      ...filter,
      ...gameInfo,
    };
  }, [gameInfo, filter]);

  const [keywordCorrelationFilter, setKeywordCorrelationFilter] = useState({
    pos: 'all',
    distance: 'all',
  });

  const [language, setLanguage] = useState('origin');
  return (
    <Content className="dbo-correlation" ref={scrollBody}>
      <Content.Header title={formatMessage({ id: 'Keyword Correlation' })} />
      <ContentBody>
        <FilterFixed
          defaultValue={DBO_TM.utcFilterRangeDay(6, 0)}
          scrollBody={scrollBody}
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter(value);
          }}
          operateShowOptions={[]}
        ></FilterFixed>

        <CardLoading loading={loading}>
          <FilterBoxCommon
            left={[{ key: 'pos' }, { key: 'distance' }]}
            right={[{ key: 'language' }]}
            // left={[{ key: 'language' }]}
            // right={[]}
            onChange={(value, key) => {
              const { language, ...rest } = value;

              if (key === 'language') {
                setLanguage(language);
              } else {
                setKeywordCorrelationFilter({
                  ...keywordCorrelationFilter,
                  ...rest,
                });
              }
            }}
          ></FilterBoxCommon>

          <KeywordCorrelationCloud
            keepParams={keepParams}
            keywordCorrelationFilter={keywordCorrelationFilter}
            language={language}
          ></KeywordCorrelationCloud>

          <KeywordCorrelationWords
            keepParams={keepParams}
            keywordCorrelationFilter={keywordCorrelationFilter}
            language={language}
          ></KeywordCorrelationWords>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(KeywordCorrelation);
